import { render, staticRenderFns } from "./LabelContent.vue?vue&type=template&id=589a0830&scoped=true&"
import script from "./LabelContent.vue?vue&type=script&lang=js&"
export * from "./LabelContent.vue?vue&type=script&lang=js&"
import style0 from "./LabelContent.vue?vue&type=style&index=0&id=589a0830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589a0830",
  null
  
)

export default component.exports